import { CatalogueRepository } from "@catalogue/data/repositories/catalogue.repository";
import { Derivation, CreateDerivation } from "@catalogue/domain/models/derivation.model";
import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { inject, injectable } from "inversify";

@injectable()
export class CreateDerivationUseCase {
    constructor(
        @inject(CatalogueRepository)
        private readonly catalogueRepository: CatalogueRepository,
    ) { }

    async execute(
        derivation: CreateDerivation
    ): Promise<Nullable<Derivation>> {
        const creationResult = await this.catalogueRepository.createDerivation(derivation);

        if (creationResult.isLeft()) {
            ToastManagerStore.error(creationResult.getLeftOrThrow().message);
        }

        return creationResult.fold(
            () => null,
            (createdDerivation) => {
                return createdDerivation;
            }
        );
    }
}